/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2UserHomeSingle/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2UserHomeSingle({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2UserHomeSingle",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#5A57DA"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2UserHomeSingle.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-ZFGkHK': alignSelf,'--mt-2-ZFGkHK': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZFGkHK': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZFGkHK': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZFGkHK': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZFGkHK': opacity,'--w-10-ZFGkHK': typeof width === 'number' ? `${width}px` : width,'--h-11-ZFGkHK': typeof height === 'number' ? `${height}px` : height,'--f-12-ZFGkHK': fill,'--a-7-ZFGkHK': isAnimated ? animation : "none",'--sd-8-ZFGkHK': isAnimated ? strokeDashoffset : 0,'--sd-9-ZFGkHK': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2UserHomeSingle.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M7 0a.79.79 0 00-.398.107c-.05.028-.097.06-.13.083-.071.05-.152.114-.235.183-.168.138-.39.331-.64.557a118.75 118.75 0 00-1.832 1.691A404.399 404.399 0 00.638 5.594c-.23.22-.4.468-.506.756A2.34 2.34 0 000 7.172v5.116C0 13.226.774 14 1.712 14h10.576c.938 0 1.712-.774 1.712-1.712V7.172c0-.31-.046-.612-.175-.906a2.318 2.318 0 00-.539-.745c-.48-.462-1.869-1.792-3.166-3.008A111.23 111.23 0 008.36.891a20.13 20.13 0 00-.612-.53 4.004 4.004 0 00-.226-.175 1.37 1.37 0 00-.13-.082A.789.789 0 007 0zM2.459 12.5h9.082a4.783 4.783 0 00-9.082 0zM7 8.156a2.156 2.156 0 100-4.312 2.156 2.156 0 000 4.312z"
 style={{'--f-12-ZFGkHK': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}